import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

let counter = 0;

function GonkBox({
                     children,
                     className,
                     style,
                     ...attrs
                 }) {
    return <div
        {...attrs}
        className={classnames(
            "gonk-box",
            "gonk-box-" + (++counter),
            className,
        )}
        style={{
            ...style,
            margin: "1em",
            padding: "1em 2em",
            border: "1px solid #ce838f",
            borderRadius: "0.3em",
            backgroundColor: "#f2dede",
            fontWeight: "bold",
            clear: "both",
        }}
    >
        {children || "Gonk! Something's Busted!"}
    </div>;
}

GonkBox.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    style: PropTypes.object,
};

export default GonkBox;



// WEBPACK FOOTER //
// ./app/views/GonkBox.js